import { createFileRoute } from '@tanstack/react-router'
import { CashSessionPage } from '@/features/cash/cash-session-page'
import { requirePermission } from '@/lib/route-guards'

/** Detalle de una caja (supervisión o la propia). */
export const Route = createFileRoute('/_app/cash/$sessionId')({
  beforeLoad: requirePermission({ anyOf: ['cash:operate', 'cash:supervise'] }),
  component: CashSessionRoute,
})

function CashSessionRoute() {
  const { sessionId } = Route.useParams()
  return <CashSessionPage sessionId={sessionId} />
}
